_BannerFlowApp.controller(
    "ListController",
    function ListController(
        $scope,
        $rootScope,
        $state,
        $timeout,
        $location,
        NgTableParams,
        Folder,
        ngDialog,
        AuthInfo,
        Utils,
        Notification,
        Brand
    ) {
        var isDuplicating = false;
        $scope.listModel = {
            MAX_NAME_LENGTH: 55,
            showItems: false,
            initialLoaded: false,
            customCallback: null,
            pagination: {
                count: 50,
                page: 1
            },
            folders: $scope.urlParams.folderId ? [] : null,
            filter: angular.extend(
                {
                    includeArchived: false,
                    users: new Array(),
                    labels: new Array(),
                    query: "",
                    showLabels: false
                },
                $scope.urlParams,
                {
                    query: $scope.urlParams.query ? $scope.urlParams.query.replace(/%2F/g, "/") : ""
                }
            ),
            filterActive: false,
            isSearching: false,
            isSearchResult: false,
            selection: {
                items: [],
                containsFolders: function () {
                    return (
                        _.find(this.items, function (i) {
                            return i.isFolder;
                        }) != null
                    );
                },
                containsLocked: function () {
                    return (
                        _.find(this.items, function (i) {
                            return i.isLocked;
                        }) != null
                    );
                },
                onlyFolders: function () {
                    return (
                        _.filter(this.items, function (i) {
                            return !i.isFolder;
                        }).length === 0
                    );
                },
                only: function (state) {
                    return (
                        _.filter(this.items, function (i) {
                            return i.state != state;
                        }).length === 0
                    );
                },
                multiple: function () {
                    return this.items.length > 1;
                }
            },
            allLabels: [],
            userOptions: null,
            addItemLoading: false
        };

        $scope.listModel.folders = $rootScope.cache ? $rootScope.cache.folders : null;

        var arrayify = function (value) {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            else return [value];
        };

        $scope.listModel.filter.includeArchived =
            $scope.listModel.filter.includeArchived === "true" ||
            $scope.listModel.filter.includeArchived === true
                ? true
                : false;
        $scope.listModel.filter.showLabels =
            $scope.listModel.filter.showLabels === "true" || $scope.listModel.filter.showLabels === true
                ? true
                : false;
        $scope.listModel.filter.users = $scope.listModel.filter.users
            ? arrayify($scope.listModel.filter.users)
            : [];
        $scope.listModel.filter.labels = $scope.listModel.filter.labels
            ? arrayify($scope.listModel.filter.labels)
            : [];

        var startFilter = {
            count: $scope.urlParams.count || $scope.listModel.pagination.count, // count per page
            sorting: {}
        };

        if ($scope.urlParams.sortf) {
            startFilter.sorting[$scope.urlParams.sortf] = $scope.urlParams.sorto || "desc";
        } else {
            startFilter.sorting = {
                modified: "desc"
            };
        }

        var parameters = {};

        $scope.listModel.tableParams = new NgTableParams(startFilter, {
            filterDelay: 0,
            isPagination: true,
            getData: function (params) {
                var filter = angular.copy($scope.listModel.filter);

                if (!$scope.listModel.firstLoad && !$scope.urlParams.preventUrlUpdate) {
                    var sorting = {};

                    for (var key in params.sorting()) {
                        sorting.field = key;
                        sorting.order = params.sorting()[key];
                    }

                    $location.search({});

                    parameters = angular.extend(filter, params.url(), {
                        sortf: sorting.field,
                        sorto: sorting.order
                    });

                    $state.go(".", parameters, {
                        notify: false
                    });
                }

                $scope.listModel.firstLoad = false;

                var itemsRequest = new $scope.listModel.resource();

                itemsRequest.onlyFolders = $scope.urlParams.foldersOnly;

                itemsRequest.folderOrder = {
                    field: Object.keys(params.sorting())[0] || "",
                    ascending:
                        params.sorting()[Object.keys(params.sorting())[0]] === "asc" ? true : false
                };

                itemsRequest.itemOrder = {
                    field: Object.keys(params.sorting())[0] || "",
                    ascending:
                        params.sorting()[Object.keys(params.sorting())[0]] === "asc" ? true : false
                };

                itemsRequest = _.extend(itemsRequest, filter);
                itemsRequest.count = parseInt(params.count());

                var promise = null;

                if ($scope.urlParams.folderId) {
                    itemsRequest.folder = $scope.urlParams.folderId;
                }

                if (
                    $scope.listModel.filter.query ||
                    ($scope.listModel.filter.labels && $scope.listModel.filter.labels.length) ||
                    ($scope.listModel.filter.users && $scope.listModel.filter.users.length)
                ) {
                    itemsRequest.includeSubFolders = true;
                } else {
                    itemsRequest.includeSubFolders = false;
                }

                if ($scope.listModel.customBrand) {
                    promise = itemsRequest.$metaBrandId({
                        brandId: $scope.listModel.customBrand
                    });
                } else {
                    promise = itemsRequest.$meta();
                }

                return promise.then(
                    async function (response) {
                        const content = response.data.data.content;

                        if (
                            $scope.listModel.type === $rootScope.OBJECT_TYPE_FEED &&
                            window["aptrinsic"]
                        ) {
                            const numberOfFeeds = content.length;
                            const brandName = AuthInfo.LoggedInUser.currentBrand.slug;
                            const feedEvent = "Feeds in brand";
                            window.aptrinsic("track", feedEvent, `${numberOfFeeds > 0} ${brandName}`);
                        }

                        $scope.listModel.initialLoaded = true;

                        if (!response.headers) {
                            $timeout(function () {
                                $scope.clearAllFilters();
                            });

                            return {};
                        }

                        $scope.listModel.hasMore = response.data.data.hasMore;

                        if ($scope.urlParams.folderId && response.data.data) {
                            $scope.listModel.folders = [];
                            $scope.listModel.folders = $scope.listModel.folders.concat(
                                response.data.data.meta.breadCrumbs || []
                            );

                            $scope.listModel.folders.push({
                                id: response.data.data.meta.id,
                                name: response.data.data.meta.name
                            });

                            if ($rootScope.cache)
                                $rootScope.cache.folders = angular.copy($scope.listModel.folders);
                        } else {
                            $scope.listModel.folders = null;

                            if ($rootScope.cache) $rootScope.cache.folders = null;
                        }

                        if (response.data.data) {
                            var items = response.data.data.content;

                            $scope.listModel.searchCount = response.data.data.searchCount;
                            $scope.listModel.totalFolders = response.data.data.totalFolders;
                        }

                        if ($scope.listModel.excludeItems) {
                            items = _.filter(items, function (item) {
                                var find = _.find($scope.listModel.excludeItems, function (i) {
                                    return item.id === i.id;
                                });
                                return !find;
                            });
                        }

                        for (var i in items) {
                            if (!items[i].name) items[i].name = "untitled";

                            if (items[i].name.length > $scope.listModel.MAX_NAME_LENGTH) {
                                items[i].nameTooltip = items[i].name;
                            }

                            if ($scope.listModel.type === $rootScope.OBJECT_TYPE_LANDINGPAGE) {
                                items[i].bfcPath = "{0}/{1}/{2}/landingpages/{3}".format(
                                    HOME_URL,
                                    AuthInfo.LoggedInUser.currentAccount.slug,
                                    AuthInfo.LoggedInUser.currentBrand.slug,
                                    items[i].slug
                                );
                            }
                        }

                        $state.go(".", parameters, {
                            notify: false
                        });

                        if ($scope.listModel.customCallback) {
                            $scope.listModel.customCallback(items);
                        }

                        if ($scope.navigationState && $scope.navigationState.selectedItem) {
                            items.filter(function (item) {
                                if (item.id === $scope.navigationState.selectedItem.id) {
                                    item.selected = true;
                                }
                            });
                        }

                        $scope.listModel.loading = false;

                        return items;
                    },
                    function () {
                        $scope.listModel.initialLoaded = true;
                    }
                );
            }
        });

        $scope.$watchCollection(
            "listModel.filter",
            function (newVal, oldVal) {
                $scope.listModel.filterActive =
                    $scope.listModel.filter.query ||
                    $scope.listModel.filter.users.length ||
                    $scope.listModel.filter.labels.length ||
                    $scope.listModel.filter.includeArchived;

                if (newVal === oldVal) return;

                $scope.reloadTable();
            },
            true
        );

        $scope.showMore = function () {
            if (!$scope.listModel.hasMore || $scope.listModel.tableParams.settings().$loading) return;

            $scope.listModel.pagination.page++;
            $scope.listModel.tableParams.count(
                $scope.listModel.pagination.page * $scope.listModel.pagination.count
            );
        };

        $scope.reloadTable = function () {
            $scope.listModel.tableParams.reload();
        };

        $scope.loadFilterOptions = function () {
            var count = 0;
            $scope.listModel.filterLoading = true;

            var callback = function () {
                count++;

                if (count == 2) {
                    $scope.listModel.filterLoading = false;
                }
            };

            $scope.loadUsers(callback);
            $scope.loadLabels(callback);
        };

        $scope.loadUsers = function (callback) {
            if ($scope.listModel.userOptions) {
                callback();
                return;
            }

            Brand.getActiveUsers(function (data) {
                $scope.listModel.userOptions = new Array();

                for (var i = 0; i < data.length; i++) {
                    var option = {
                        sort: data[i].name + i,
                        id: data[i].id,
                        text: data[i].name
                    };
                    $scope.listModel.userOptions.push(option);
                }
                callback();
            });
        };

        $scope.loadLabels = function (callback) {
            if ($scope.listModel.allLabels.length > 0) {
                callback();
                return;
            }

            Brand.getLabels(function (data) {
                $scope.listModel.allLabels = data;

                $scope.listModel.labelOptions = new Array();

                for (var i = 0; i < data.length; i++) {
                    var option = {
                        sort: data[i],
                        id: data[i],
                        text: data[i]
                    };
                    $scope.listModel.labelOptions.push(option);
                }
                callback();
            });
        };

        $scope.clearSearchQuery = function () {
            $scope.listModel.filter.query = "";
        };

        $scope.clearAllFilters = function () {
            $scope.listModel.filter = {
                includeArchived: false,
                users: new Array(),
                labels: new Array(),
                query: "",
                showLabels: false
            };
        };

        $scope.addFolder = function () {
            if (!$scope.listModel.folderName || $scope.listModel.folderName.length > 75) return;

            $scope.listModel.addFolderLoading = true;

            var folder = new Folder();

            folder.name = $scope.listModel.folderName;
            folder.type = $scope.listModel.type;
            folder.folder = $scope.urlParams.folderId || null;

            folder.$create(function () {
                $scope.listModel.addFolderLoading = false;

                $scope.reloadTable();
                $scope.listModel.folderName = "";

                $(window).trigger("mousedown");
            });
        };

        $scope.openMoveTo = function () {
            var dialog = ngDialog.open({
                className: "move-to-dialog",
                template: "/legacy-app/views/Dialogs/move-to.html",
                controller: "MoveToDialogController",
                data: {
                    type: $scope.listModel.type,
                    folderId: $scope.urlParams.folderId,
                    itemsUrl: $scope.listModel.itemsUrl,
                    items: angular.copy($scope.listModel.selection.items)
                },
                appendTo: "body"
            });

            dialog.closePromise.then(function (data) {
                if (data.value !== "cancel") {
                    $scope.deselect();
                    $scope.reloadTable();
                }
            });
        };

        $scope.moveItems = function (items, folder, callback) {
            var promise = $scope.listModel.resource.drop(
                {
                    items: items,
                    folder: folder
                },
                function () {
                    $scope.deselect();

                    if (callback) callback();
                }
            );
        };

        $scope.deleteItems = function () {
            if ($scope.listModel.selection.containsLocked()) {
                return;
            }

            var promise = deleteItems();
            return promise.$promise;
        };

        var deleteItems = function () {
            return $scope.listModel.resource.state(
                {
                    items: $scope.listModel.selection.items,
                    state: $rootScope.OBJECT_STATE_DELETED
                },
                function (response) {
                    if (response.ok) {
                        $scope.deselect();
                        $scope.reloadTable();
                    } else {
                        response.showNotification = true;
                    }
                }
            );
        };

        $scope.archiveItems = function () {
            if ($scope.listModel.selection.containsLocked()) return;

            var promise = $scope.listModel.resource.state(
                {
                    items: $scope.listModel.selection.items,
                    state: $rootScope.OBJECT_STATE_ARCHIVED
                },
                function (response) {
                    if (response.ok) {
                        $scope.deselect();
                        $scope.reloadTable();
                    }
                }
            );

            return promise.$promise;
        };

        $scope.activateItems = function () {
            if ($scope.listModel.selection.containsLocked()) return;

            var promise = $scope.listModel.resource.state(
                {
                    items: $scope.listModel.selection.items,
                    state: $rootScope.OBJECT_STATE_ACTIVE
                },
                function (response) {
                    if (response.ok) {
                        $scope.deselect();
                        $scope.reloadTable();
                    }
                }
            );

            return promise.$promise;
        };

        $scope.lockItems = function (lock) {
            if (
                $scope.listModel.selection.containsFolders() &&
                !$scope.listModel.selection.containsLocked()
            )
                return;

            var dialog = ngDialog.open({
                className: "confirm-click-dialog",
                template: "/legacy-app/views/Dialogs/confirmLock.html",
                controller: "ConfirmLockDialogController",
                data: {
                    items: _.filter(angular.copy($scope.listModel.selection.items), function (i) {
                        return i.isLocked != lock;
                    }),
                    resource: $scope.listModel.resource,
                    type: $scope.listModel.type,
                    lock: lock
                },
                appendTo: "body"
            });

            dialog.closePromise.then(function (data) {
                if (data.value === "reload") {
                    $scope.deselect();
                    $scope.reloadTable();
                }
            });
        };

        $scope.duplicateItems = function () {
            if ($scope.listModel.selection.multiple()) return;

            if (isDuplicating) {
                return;
            }

            isDuplicating = true;
            if ($scope.listModel.type === $rootScope.OBJECT_TYPE_FEED) {
                var dialog = ngDialog.open({
                    className: "duplicate-dialog",
                    template: "/legacy-app/views/Create/Duplicate/duplicate-dialog.html",
                    controller: "DuplicateDialogController",
                    data: {
                        item: $scope.listModel.selection.items[0],
                        type: $scope.listModel.type,
                        folderId: $scope.urlParams.folderId,
                        autoStart: false
                    },
                    appendTo: "body"
                });

                dialog.closePromise.then(function (result) {
                    if (result.value === "reload") {
                        $scope.reloadTable();
                        $scope.deselect();
                    }
                    isDuplicating = false;
                });
            } else if ($scope.listModel.type === $rootScope.OBJECT_TYPE_LANDINGPAGE) {
                $scope.listModel.resource.duplicate(
                    {
                        id: $scope.listModel.selection.items[0].id,
                        folder: $scope.urlParams.folderId || null
                    },
                    function () {
                        $scope.deselect();
                        isDuplicating = false;
                        $scope.reloadTable();
                    }
                );
            }
        };

        $scope.changeItemName = function (item) {
            $scope.listModel.tableParams.settings().$loading = true;
            Folder.rename(
                {
                    name: item.name,
                    id: item.id,
                    type: item.isFolder ? $rootScope.OBJECT_TYPE_FOLDER : $scope.listModel.type
                },
                function (result) {
                    if (result.status === "error") {
                        Notification.Show(result.error, 6000, "error");
                    }
                    $scope.reloadTable();
                }
            );
        };

        $scope.deselect = function () {
            $(window).trigger("click");
            $scope.listModel.selection.items = [];
        };

        $scope.itemsDropped = function (folder, items) {
            if (!items) {
                items = $scope.listModel.selection.items;
            }

            if (AuthInfo.CanMove()) {
                var promise = $scope.listModel.resource.drop(
                    {
                        items: items,
                        folder: folder
                    },
                    function () {
                        $scope.deselect();
                        $scope.reloadTable();
                    }
                );
            } else {
                var diag = ngDialog.open({
                    className: "confirm-click-dialog",
                    template: "/legacy-app/views/Dialogs/forbidden-move-dialog.html",
                    appendTo: "body"
                });
                diag.closePromise.then(function (result) {
                    $scope.reloadTable();
                    $scope.deselect();
                });
            }
        };

        $scope.itemsSelected = function (ids) {
            $scope.listModel.selection.items = ids;
        };

        $scope.shouldEmptyStateShow = function () {
            return (
                !$scope.urlParams.folderId &&
                !$scope.listModel.filterActive &&
                !$scope.listModel.tableParams.data.length &&
                !$scope.listModel.tableParams.settings().$loading
            );
        };

        $scope.shouldEmptyFolderShow = function () {
            return (
                $scope.urlParams.folderId &&
                !$scope.listModel.filterActive &&
                !$scope.listModel.tableParams.data.length &&
                !$scope.listModel.tableParams.settings().$loading
            );
        };

        $scope.getItemsName = function () {
            const numberOfItems = $scope.listModel.selection.items.length;
            const isOnlyFolders = $scope.listModel.selection.onlyFolders();
            const isAtleastOneFolder = $scope.listModel.selection.containsFolders();
            const isOnlyOne = numberOfItems === 1;

            const isAMixOfThings = !isOnlyOne && !isOnlyFolders && isAtleastOneFolder;

            const itemType = Utils.GetObjectTypeName($scope.listModel.type);

            itemName = isOnlyFolders ? "folder" : itemType;

            phrasedThings = isOnlyOne
                ? `this ${itemName}`
                : isAMixOfThings
                  ? "these"
                  : `${numberOfItems} ${itemName}s`;

            return phrasedThings;
        };
    }
);
